import { keys } from 'lodash-es';
import { FilterType } from '../agreementsDashboardFilters';
const noVerbFilters = new Set([
    FilterType.HasCredit,
    FilterType.HasAmendments,
    FilterType.AmendmentsStatus,
    FilterType.Automatic
]);
export const showVerbFor = (filter)=>!noVerbFilters.has(filter);
export const asOptions = (config)=>config.options.map((option)=>typeof option === 'string' ? {
            value: option,
            label: option
        } : option);
export const availableFilterCount = (filterGroups, filterConfig)=>{
    if (filterGroups == null) return keys(filterConfig).length;
    return filterGroups.reduce((sum, group)=>sum + group.filters.length, 0);
};
